"use client";

import { c as _c } from "react/compiler-runtime";
import { XCircleIcon } from "lucide-react";
import { useCallback } from "react";
import { cn } from "@/lib/utils";
import { useUpload } from "./use-upload";
// @todo this should probably be called `LargeVideoUpload`
export const LargeFileUploadAdapter = t0 => {
  const $ = _c(26);
  const {
    images,
    onUpload,
    onDelete,
    className,
    name
  } = t0;
  const currentImage = images[0];
  let t1;
  if ($[0] !== onUpload) {
    t1 = fileUrl => {
      onUpload(fileUrl, {
        width: 1920,
        height: 1080
      });
    };
    $[0] = onUpload;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleUpload = t1;
  let t2;
  if ($[2] !== currentImage || $[3] !== onDelete) {
    t2 = () => {
      console.log("dsadsadsa", {
        currentImage
      });
      if (currentImage) {
        onDelete(currentImage);
      }
    };
    $[2] = currentImage;
    $[3] = onDelete;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDelete = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentImage || $[7] !== handleUpload) {
    t4 = {
      clientPayload: t3,
      storeId: "@todo",
      environment: "live",
      bucket: "hero-media",
      defaultValue: currentImage,
      onUpload: handleUpload
    };
    $[6] = currentImage;
    $[7] = handleUpload;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    inputFileRef,
    progress,
    isUploading,
    handleFileChange
  } = useUpload(t4);
  let t5;
  if ($[9] !== className) {
    t5 = cn("space-y-2", className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== currentImage || $[12] !== handleDelete) {
    t6 = currentImage && <div className="relative">{currentImage.toLowerCase().endsWith(".mp4") || currentImage.toLowerCase().endsWith(".webm") || currentImage.toLowerCase().endsWith(".ogg") ? <video src={currentImage} className="w-full aspect-video object-cover rounded-md" muted={true} playsInline={true} /> : <img src={currentImage} alt="Preview" className="w-full aspect-video object-cover rounded-md" />}<button type="button" onClick={handleDelete} className="absolute right-0 top-0 p-1 opacity-70 transition-opacity hover:opacity-100" title="Delete media"><XCircleIcon className="h-4 w-4 fill-white" /><span className="sr-only">Delete media</span></button></div>;
    $[11] = currentImage;
    $[12] = handleDelete;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== className || $[15] !== currentImage || $[16] !== handleFileChange || $[17] !== inputFileRef || $[18] !== isUploading || $[19] !== name || $[20] !== progress) {
    t7 = !currentImage && <div className="relative"><input name={name} ref={inputFileRef} type="file" accept="image/*,video/*" disabled={isUploading} className={cn("flex cursor-pointer hover:bg-neutral-100 transition-all rounded-md w-full px-3 py-2 text-sm border border-input bg-background ring-offset-background", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "disabled:cursor-not-allowed disabled:opacity-50", "file:border-0 file:bg-transparent file:text-sm file:font-medium", className)} onChange={handleFileChange} />{isUploading && <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded-md"><div className="text-sm text-gray-600">Uploading... {progress.toFixed(0)}%</div></div>}<progress value={progress} max={100} className={cn("absolute bottom-0 h-1 w-full rounded-b-md", "[&::-webkit-progress-bar]:rounded-b-md [&::-webkit-progress-bar]:bg-blue-200", "[&::-webkit-progress-value]:bg-blue-600")} /></div>;
    $[14] = className;
    $[15] = currentImage;
    $[16] = handleFileChange;
    $[17] = inputFileRef;
    $[18] = isUploading;
    $[19] = name;
    $[20] = progress;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};